import { render, staticRenderFns } from "./ConfirmAppliedCopyrightSplit.vue?vue&type=template&id=07487404&scoped=true&"
import script from "./ConfirmAppliedCopyrightSplit.vue?vue&type=script&lang=js&"
export * from "./ConfirmAppliedCopyrightSplit.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAppliedCopyrightSplit.vue?vue&type=style&index=0&id=07487404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07487404",
  null
  
)

export default component.exports